import { render, staticRenderFns } from "./PresaleRate.vue?vue&type=template&id=4cfca321&"
import script from "./PresaleRate.vue?vue&type=script&lang=js&"
export * from "./PresaleRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports